import React from 'react'
import TransitionBanner from '../components/TransitionBanner'
import Header from '../components/Header'
import Pricing from '../components/Pricing'
import SignupBand from '../components/SignupBand'
import Footer from '../components/Footer'

const PricingPage: React.FC = () => (
  <div className="min-h-screen">
    <TransitionBanner />
    <Header />
    <main>
      <Pricing showFaq />
      <SignupBand />
    </main>
    <Footer />
  </div>
)

export default PricingPage
